import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { inject, observer } from 'mobx-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import ErrorMessage from './ErrorMessage';

// For log in to company.
// In drawer list we show companies with [LockIcon] when they have password protection.
// When user tries to log into password protected company we show [LoginDialog].
// Uses [viewStore] to control dialog and [authStore] to login to the company. 

@inject('authStore', 'viewStore')
@observer
export default class LoginDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { password: "", passwordError: false }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleLogin() {
        if (this.state.password === "") {
            this.setState({ passwordError: true });
        }
        else {
            this.setState({ password: "" });
            this.props.authStore.setTempCompanyPassword(this.state.password);
            this.props.authStore.loginCompany();
        }

    }

    handleClose() {
        this.props.viewStore.closeLoginDialog();
    }
    render() {
        const { authStore, viewStore } = this.props;
        return (
            <div>
                <Dialog open={viewStore.showLoginDialog} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                >
                    <DialogTitle id="form-dialog-title">Yritys jonka valitsit vaatii salasanan</DialogTitle>
                    <DialogContent>
                        {
                            // Check if loading. If Loading show [CircularProgress].
                            authStore.loginDialogLoading
                                ?
                                // Using [Grid] to center the [CircularProgress].
                                <Grid
                                    container
                                    justifyContent="center"
                                >
                                    <Grid item>
                                        <CircularProgress size={70} />
                                    </Grid>
                                </Grid>
                                :
                                // If not loading show [companyName] and password [TextField].
                                <div>
                                    <DialogContentText component={'span'} variant="h6">{authStore.tempCompany.NAME}</DialogContentText>
                                    <br></br>

                                    <TextField
                                        id="password"
                                        margin="dense"
                                        label="Salasana"
                                        type="password"
                                        autoFocus
                                        autoComplete="current-password"
                                        fullWidth
                                        value={this.state.password}
                                        onChange={e => this.setState({ password: e.target.value })}
                                        error={this.state.passwordError}

                                    />
                                    <br></br>
                                    <ErrorMessage />

                                </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleLogin} color="primary">
                            Kirjaudu sisään
                        </Button>
                        <Button onClick={this.handleClose} >
                            Peruuta
                        </Button>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }

}